import React from 'react'
import {Route , Redirect}  from 'react-router-dom';
import {isAutheticated} from './index' 

const PrivateRoute = ({component:Component, ...rest}) => {
    return (
        <Route {...rest} render={(props) => (
            isAutheticated()
              ? <Component {...props} />
              : <Redirect to='/signin' />
          )} />
    )
}

export default PrivateRoute;